import { fi, nb, sv } from "date-fns/locale";

import { format } from "date-fns";

const formatDate = (date: number | Date, dateFormat = "yyyy-MM-dd", locale = "sv_SE") => {
    if (!date) {
        return null;
    }

    const options: any = {};
    const isoLocale: string = (locale || "sv_SE").slice(0, 2);
    const dateLocales: any = { sv, fi, nb };
    const dateLocale = dateLocales[isoLocale];
    if (dateLocale) {
        options["locale"] = dateLocale;
    }

    return format(date, dateFormat, options);
};

export default formatDate;
